const requireImplementation = (functionName) => {
    throw new Error(`${functionName} must be implemented`);
};

class BaseProvider
{
    isInitialised()
    {
        requireImplementation('isInitialised');
    }

    init()
    {
        requireImplementation('init');
    }

    trackEvent()
    {
        requireImplementation('trackEvent');
    }

    resetIdentity()
    {
        requireImplementation('resetIdentity');
    }
}

export default BaseProvider;
